import { authenticatedInstance, unauthenticatedInstance } from "./instance";
// import axios from "axios";

export const fileUpload = (filelist: File[], authenticated: boolean) => {
  let instance: any = null;
  if (authenticated) {
    instance = authenticatedInstance;
  } else {
    instance = unauthenticatedInstance;
  }
  let formData = new FormData();
  filelist.forEach((file: any) => {
    formData.append("files", file);
  });
  return instance.post("/file/upload", formData);
};

export const uploadtoS3 = async (
  url: any,
  file: any
  // onUploadProgress: any
) => {
  // console.log("----FILE IS------------------->", file);
  // const fileBody = await getBlob(file.path);
  // let config: any = {
  //   method: "put",
  //   url: url,
  //   headers: {
  //     "Content-Type": file.type,
  //   },
  //   data: file,
  // };
  let myHeaders = new Headers();
  myHeaders.append(
    "Content-Type",
    file.type === "" && file.name.includes(".stl") ? "model/stl" : file.type
  );
  const requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: file,
  };
  return fetch(url, requestOptions);
};

// export const getBlob = async (fileUri: any) => {
//   const resp = await fetch(fileUri);
//   const imageBody = await resp.blob();
//   return imageBody;
// };
